var _defs, _path, _path2, _path3, _circle, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpsgenie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-20 -65 500 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 30.03,
    y1: 6.57,
    x2: 30.03,
    y2: 43.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2684ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0052cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 19.05,
    y1: 42.17,
    x2: 31.32,
    y2: 67.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2684ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0052cc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.21 32.22c0-17.62 10.14-30 28.21-30s28.13 12.37 28.13 30c0 17.8-10.15 30.26-28.13 30.26S84.21 50 84.21 32.22zm8 0c0 12.37 5.78 22.61 20.2 22.61s20.11-10.24 20.11-22.61c0-12.1-5.78-22.34-20.11-22.34S92.22 20.12 92.22 32.22z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.54 53.76V79h-7.65V17.09h7.65v8c2.85-5.87 8.19-8.9 15-8.9 11.84 0 17.8 10.06 17.8 23.14 0 12.55-6.23 23.14-18.69 23.14-6.45.01-11.44-2.93-14.11-8.71zm13-30.44c-6.86 0-13 4.36-13 14.24v3.56c0 9.88 5.61 14.24 12.11 14.24 8.63 0 13.08-5.69 13.08-16 0-10.7-4.27-16.04-12.19-16.04z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M213.26 62.48a34.28 34.28 0 01-15.49-3.29v-8.1a34.84 34.84 0 0015.84 4.36c5.88 0 8.9-2.4 8.9-5.87s-2.58-5.34-11-7.39c-9.88-2.4-14.07-6.23-14.07-13.53 0-7.74 6-12.46 16.11-12.46a31.58 31.58 0 0114.33 3.2v7.93c-5.34-2.68-9.7-4.1-14.42-4.1-5.6 0-8.63 2-8.63 5.43 0 3.12 2.14 5.07 10.32 7C225 38.09 230 41.74 230 49.49c0 7.39-4.82 12.99-16.74 12.99zM268.79 53.58c-2.85 5.88-8.19 8.9-15 8.9-11.75 0-17.62-10.06-17.62-23.14 0-12.55 6.14-23.14 18.51-23.14 6.5 0 11.48 2.94 14.15 8.72v-7.83h7.48v40.5c0 13.08-6.14 21.89-22.08 21.89a44.93 44.93 0 01-15.84-2.4V69.6a49.26 49.26 0 0015.49 2.67c11.12 0 15-6 15-14.24zm-13 1.78c6.85 0 13-4.36 13-14.24v-3.56c0-9.88-5.61-14.24-12.1-14.24-8.64 0-13.09 5.7-13.09 16 0 10.68 4.27 16.04 12.2 16.04zM309.11 62.48c-16.65 0-23.95-9.61-23.95-23.23 0-13.44 7.48-23 21-23 13.71 0 19.22 9.52 19.22 23.05v3.47h-32.47c1.07 7.57 6 12.46 16.46 12.46a39.48 39.48 0 0013.53-2.4v7c-3.65 1.94-9.25 2.65-13.79 2.65zm-16.29-26.34h24.83c-.44-8.28-4.18-13-11.84-13-8.1 0-12.19 5.25-12.99 13zM372.3 61.59h-7.66V34.71c0-8-3.2-11.57-10.5-11.57-7.12 0-12 4.72-12 13.71v24.74h-7.65v-44.5h7.65v7.3a15.61 15.61 0 0114.07-8.19c10.23 0 16.11 7 16.11 19.31zM386.89 0a5 5 0 015.34 5.34 5.34 5.34 0 01-10.68 0A5 5 0 01386.89 0zM383 17.09h7.66v44.5H383zM423.47 62.48c-16.65 0-23.94-9.61-23.94-23.23 0-13.44 7.47-23 21-23 13.71 0 19.23 9.52 19.23 23.05v3.47h-32.49c1.07 7.57 6 12.46 16.47 12.46a39.57 39.57 0 0013.53-2.4v7c-3.65 1.94-9.27 2.65-13.8 2.65zm-16.29-26.34H432c-.44-8.28-4.18-13-11.83-13-8.09 0-12.17 5.25-12.99 13z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.03,
    cy: 18.48,
    r: 17.84,
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.51 71.7A86.06 86.06 0 01.26 42.17a2 2 0 01.87-2.77l13.51-6.63a2 2 0 012.61.8 66.79 66.79 0 0029 26.25 86.5 86.5 0 01-14.7 11.88 2.87 2.87 0 01-3.04 0z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2684ff",
    d: "M31.55 71.7A86 86 0 0059.8 42.17a2 2 0 00-.86-2.77l-13.52-6.63a2 2 0 00-2.61.8 66.76 66.76 0 01-29 26.25 86 86 0 0014.7 11.88 2.87 2.87 0 003.04 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpsgenie);
export default __webpack_public_path__ + "static/media/Opsgenie.9d5da93f.svg";
export { ForwardRef as ReactComponent };